import { render, staticRenderFns } from "./AvgAmountOnRechargeTime.vue?vue&type=template&id=54352044&"
import script from "./AvgAmountOnRechargeTime.vue?vue&type=script&lang=js&"
export * from "./AvgAmountOnRechargeTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports